import { resolvePlatformEventsUrl } from './resolvePlatformEventsUrl'
import { logError } from '../../Helpers'
import { PlatformEventEvents } from '../constants/PlatformEventsEvents'
import { PlatformEventScopes } from '../constants/PlatformEventsScopes'

export interface BroadcastPlatformEventProps {
    scope: PlatformEventScopes
    code: string
    event?: PlatformEventEvents
    message?: string
}
/**
 * IMPORTANT!! Broadcasting platformEvents has not yet been done outside of POC. // TODO: remove this comment when this is no longer accurate.
 * Be aware that it might need some tweaking before usage
 */
export interface BroadcastPlatformEventRequestBody {
    event: PlatformEventEvents | undefined
    message: string | undefined
}
export const broadcastPlatformEvent = async ({ scope, code, event, message }: BroadcastPlatformEventProps) => {
    const url = await resolvePlatformEventsUrl(scope, code)
    if (!url) {
        logError('could not resolve platform events url', { caller: 'broadcastPlatformEvent' })
        return
    }

    const body: BroadcastPlatformEventRequestBody | undefined = !!event || !!message ? { message, event } : undefined

    try {
        await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: body ? JSON.stringify(body) : undefined,
        })
    } catch {
        logError('could not broadcast server-sent event', { caller: 'broadcastPlatformEvent' })
    }
}
